import { Pipe, PipeTransform } from '@angular/core';

import { Tier } from '../models/SubscriptionTier.model';
import { StateService } from '../state/state.service';
import { ApiUser } from '../models/Profile.model';

/**
 * Pipe to check if a given tier or array of tiers matches the current server's tier.
 *
 * Usage:
 * Single tier check:
 *   {{ 'core' | tier }}
 *   Returns true if the current server's tier is 'core', false otherwise.
 *
 * Multiple tier check:
 *   {{ ['core', 'plus'] | tier }}
 *   Returns true if the current server's tier is either 'core' or 'plus', false otherwise.
 *
 * @param value - A single tier (Tier[number]) or an array of tiers (Array<Tier[number]>)
 * @returns A boolean indicating whether the current tier matches the input
 */
@Pipe({
  name: 'tier',
  pure: true,
  standalone: false,
})
export class TierPipe implements PipeTransform {
  constructor(private state: StateService) {}

  transform(value: Tier[number] | Array<Tier[number]>) {
    const user = this.state.get<ApiUser>('user');
    if (user?.permissions?.includes('ADMIN')) {
      return true;
    }

    const currentTier = this.getCurrentTier();
    if (currentTier === 'grandfather') {
      return true;
    }

    if (currentTier === 'demo') {
      // If the current tier is 'demo', we assume it matches any tier check
      // This can be adjusted based on specific requirements for demo mode
      return true;
    }

    if (Array.isArray(value)) {
      return value.includes(currentTier);
    }
    return value === currentTier;
  }

  private getCurrentTier(): Tier {
    const tier = this.state.get('selectedServer')?.tier;
    return tier ?? 'grandfather';
  }
}
